import { CONSTANTS } from '@shared/constants';

export const ACCOUNT_USERS_ROUTES_PATHS_PARTIALS = {
  BASE_PATH: CONSTANTS.ROUTES.USERS,
  INVITE: CONSTANTS.ROUTES.INVITE,
  EDIT: `${CONSTANTS.ROUTES.EDIT}/:${CONSTANTS.ROUTE_PARAMS.USER_ID}`,
};
export const ACCOUNT_USERS_ROUTES_PATHS_FULL = {
  INVITE: `${ACCOUNT_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_USERS_ROUTES_PATHS_PARTIALS.INVITE}`,
  EDIT: `${ACCOUNT_USERS_ROUTES_PATHS_PARTIALS.BASE_PATH}/${ACCOUNT_USERS_ROUTES_PATHS_PARTIALS.EDIT}`,
};
